export default {"src":"/_next/static/media/DgMuthootEximNewLogo.20ba4fc7.svg","height":143,"width":200,"blurWidth":0,"blurHeight":0};